<div
  [class]="hostClass"
  [style.width.px]="resolvedSize"
  [style.height.px]="resolvedSize"
  [style.font-size.px]="fontSize"
  [style.border-width.px]="borderWidth"
  >
  @if (displayImg) {
    <img [src]="displayImg" alt="" />
  }
  @if (!displayImg) {
    <span>{{ initials }}</span>
  }
</div>
@if (bounty > 0) {
  <span class="member-avatar__bounty">
    <bv-icon svgIcon="bounty"></bv-icon>{{ bounty }}
  </span>
}
